import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["children", "style", "className"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import './styles.sass';

/**
 * Wraps any component and overlays a file input.
 */
var FileButton = /*#__PURE__*/function (_React$Component) {
  function FileButton() {
    var _this;
    _classCallCheck(this, FileButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FileButton, [].concat(args));
    _this.onChange = function (e) {
      var handler = _this.props.onChange;
      if (handler) handler(e.target.files);
    };
    return _this;
  }
  _inherits(FileButton, _React$Component);
  return _createClass(FileButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        style = _this$props.style,
        className = _this$props.className,
        props = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement("div", {
        className: cx('FileButton', className),
        style: style
      }, children, /*#__PURE__*/React.createElement("input", _extends({
        multiple: false,
        value: ""
      }, props, {
        type: "file",
        onChange: this.onChange,
        className: "FileButton__input"
      })));
    }
  }]);
}(React.Component);
export { FileButton as default };
FileButton.propTypes = {
  onChange: PropTypes.func,
  children: PropTypes.element,
  className: PropTypes.string,
  style: PropTypes.any
};
//# sourceMappingURL=index.js.map
